import React from 'react';

const Unauthorized = () => <div><div><h1>You are not authorized to view the requested information</h1></div>
                          <div><h3>Please clear the cache or use incognito window for login</h3></div>
                          </div>;

export default Unauthorized;
